export default __webpack_public_path__ + "static/media/Location_Schleswig-Holstein.b5844bfe.svg";